import { create } from 'zustand'
import {
  ILoadingStore,
  ILocaleStore,
  INavbarStore,
  ISidebarStore,
  IContentStore,
  IHideHeaderStore,
  ISearchItemsStore,
  IContentRequestedStore,
  IDataLeftMenuSelected,
  IDataCurlStore,
  IDataCurlTypeStore,
  IDataCurlProductTypeStore
} from './storeTypes'
import pt from '../locale/pt.json'
import en from '../locale/en.json'

const DataLoadingStore = create<ILoadingStore>((set) => ({
  loadingList: false,
  loadingDescription: false,
  setLoadingList: (loadingList: boolean) => set({ loadingList }),
  setLoadingDescription: (loadingDescription: boolean) =>
    set({ loadingDescription })
}))

type LocaleJson = typeof pt

const DataLocaleStore = create<ILocaleStore<LocaleJson>>((set) => ({
  localeSelected: 'PT',
  listLocale: ['PT', 'EN'],
  jsonSelected: pt,
  setLocale: (localeSelected: string) => set({ localeSelected }),
  setJsonSelected: (localeSelected: string) =>
    set({ jsonSelected: localeSelected === 'PT' ? pt : en })
}))

const DataLeftMenuSelected = create<IDataLeftMenuSelected>((set) => ({
  leftMenuItemSelected: '',
  setLeftMenuItemSelected: (leftMenuItemSelected: string) =>
    set({ leftMenuItemSelected })
}))

// ----------------------------------------------------------
const DataNavbarStore = create<INavbarStore>((set) => ({
  navbarSelected: '',
  listNavbar: [],
  setNavbar: (navbarSelected: string) => set({ navbarSelected }),
  setListNavbar: (listNavbar: INavbarStore['listNavbar']) => set({ listNavbar })
}))

const DataSidebarStore = create<ISidebarStore>((set) => ({
  listSidebar: [],
  setListSidebar: (listSidebar: ISidebarStore['listSidebar']) =>
    set({ listSidebar })
}))
// ----------------------------------------------------------

const DataContentStore = create<IContentStore>((set) => ({
  content: {},
  setContent: (content: IContentStore['content']) => set({ content })
}))

const DataHideHeaderStore = create<IHideHeaderStore>((set) => ({
  hideHeader: false,
  setHideHeader: (hideHeader: boolean) => set({ hideHeader })
}))

const DataSearchItemsStore = create<ISearchItemsStore>((set) => ({
  searchItems: [],
  setSearchItems: (searchItems: any) => set({ searchItems })
}))

const DataContentRequestedStore = create<IContentRequestedStore>((set) => ({
  contentRequested: [] as any[],
  setContentRequested: (contentRequested: any) =>
    set((state) => ({
      contentRequested: [...state.contentRequested, contentRequested]
    })),
  setClearContentRequested: () =>
    set(() => ({
      contentRequested: []
    }))
}))

const DataUrlCurlStore = create<IDataCurlStore>((set) => ({
  urlCurl: '',
  setUrlCurl: (urlCurl: string) => set({ urlCurl })
}))

const DataCurlTypeStore = create<IDataCurlTypeStore>((set) => ({
  typeCurl: '',
  setTypeCurl: (typeCurl: string) => set({ typeCurl })
}))

const DataCurlProductTypeStore = create<IDataCurlProductTypeStore>((set) => ({
  productTypeCurl: '',
  setProductTypeCurl: (productTypeCurl: string) => set({ productTypeCurl })
}))

const stores = {
  DataLoadingStore,
  DataLocaleStore,
  DataLeftMenuSelected,
  DataNavbarStore,
  DataSidebarStore,
  DataContentStore,
  DataHideHeaderStore,
  DataSearchItemsStore,
  DataContentRequestedStore,
  DataUrlCurlStore,
  DataCurlTypeStore,
  DataCurlProductTypeStore
}

export default stores
